import {
  apiClient,
  ApiClientConfig,
  PaginatedRequestParams,
  PaginatedResponse,
} from 'api';
import { axiosInstance } from 'api/axios-instance';
import { AxiosResponse } from 'axios';
import { CONFIG } from 'config';
import {AddRole, roleTypeLists, SaveRolePrivilegePermissionsDTO, SaveUserPermissionsDTO, UpdateRole, UpdateRoleResponse} from 'features/users/types' ;
import {NotificationList, PermissionRow, User } from 'types';
type userMenu = {
  id: string;
  menu: string;
  isPermission: boolean;
}
export interface GetUserListResponse extends User {
  "Menu": userMenu[]
}

 interface BaseResponse<T> {
  rs: number;
  res?: T;
  rc?: any[]; // if this is always an array, or refine as needed
  msgkey?: string | null;
  ukey?: string;
  customMessage?: string;
  itemId?: number;
  totalRecords?: number;
}

export interface UserListParams extends PaginatedRequestParams {
  full_user_name?: string;
  phone_number?: string;
  roles?: string[];
  company_id?: string;
  created_at_from?: string; // ISO8601_FORMAT
  created_at_to?: string; // ISO8601_FORMAT
}

export type VolunteerUserDTO = {
  Name: string;
  EventId: string;
  Email: string;
  PhoneNo: string;
  Password: string;
  IsRefundAllowed: boolean;
  Status: boolean;
};


export type CreateUserDTO = {
  name: string;
  email?: string | null;
  phoneNumber: string;  
  roleType:number ;
  isActive: boolean;
  password: string;
  
};




export type UpdateUserRoleDTO = {
  user_id: string | undefined;
  MenuIds: string[];
}

export type UpdateUserDTO = {
  userId: string;
  email?: string | null;
  name?: string;  
  password?: string;
  phoneNumber?: string;
  isActive?: boolean;
  roleType?: number; 
};

export type ReadNotificationDTO = {
 notificationId:number ;
};

export type UserResponse = BaseResponse<PaginatedResponse<User>>;

export type NotificationListResponse = BaseResponse<PaginatedResponse<NotificationList>>;
export type EventList = {
  Id: string;
  Text: string;
  Value: string;
}

export type CraeteTitleCmsrDTO = {
  id?: string,
  title: string,
  is_active: boolean,
}

type NoResult = object;

export const UserApiService = () => {
  const createUser = async (
    payload: CreateUserDTO,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<BaseResponse<User>>({
      ...callConfig,
      endpoint: `/auth/signup`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
 const createStationMapping = async (
    payload: CreateUserDTO,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<BaseResponse<User>>({
      ...callConfig,
      endpoint: `/Masters/AddStationMapUser`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

  const getUser = async (id: string, callConfig?: Partial<ApiClientConfig>): Promise<BaseResponse<User>> => {
    const response: AxiosResponse<BaseResponse<User>> = await apiClient<BaseResponse<User>>({
      ...callConfig,
      endpoint: `/Admin/GetUser/${id}`,
    });
        
    return {
      res: response.data.res,
      rs: response.status,
    };
  };

  const getUserMapping = async (id: string, callConfig?: Partial<ApiClientConfig>): Promise<BaseResponse<User>> => {
    const response: AxiosResponse<BaseResponse<User>> = await apiClient<BaseResponse<User>>({
      ...callConfig,
      endpoint: `/Admin/GetUserStationUser/${id}`,
    });
        
    return {
      res: response?.data,
    }as any;
  };

  const getUsers = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<UserResponse>({
      ...callConfig,
      endpoint: `/Admin/GetUserList`,
      params,
    });
       
    return response.data;
  };

  

  const updateUser = async (
    payload: UpdateUserDTO,
    callConfig?: Partial<ApiClientConfig>,
  ) => {  
    //const { userId, ...data } = payload;
    const data = payload ;
    const response = await apiClient<BaseResponse<User>>({
      ...callConfig,
      endpoint: `/Admin/UpdateUser`,
      method: 'PATCH',
      data,
    });
    
    return response.data.rs;
  };

   
  const getRole = async () => {
    const response = await apiClient({
      endpoint: ""
    });

    return response.data;
  };

  const updateUserRole = async (
    payload: UpdateUserRoleDTO,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const { ...data } = payload;

    const response = await apiClient({
      ...callConfig,
      endpoint: `/admin/users/updatemenupermissions`,
      method: 'POST',
      data,
    });

    return response.data;
  };

  const uploadUserProfileImage = async (formData: FormData) => {
    const response = await axiosInstance.post(
      `${CONFIG.SUFFIX_API_BASE_URL}/v1/users/profile_picture`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data;
  };


  const updateUserStatus = async (payload: any) => {
    const response = await apiClient({
      endpoint: `/admin/UpdateUserStatus`,
      method: 'POST',
      data: payload,
    });
        
    return response.data;
  };

  const getRoleTypeList = async () => {
    const response = await apiClient<BaseResponse<roleTypeLists>>({
      endpoint: `/admin/GetRoleType`,
      method: 'GET'      
    });
   
    return response.data?.rc;
  };
 


const getUserRolePermissionList = async (id: string, callConfig?: Partial<ApiClientConfig>): Promise<BaseResponse<PermissionRow[]>> => {
    const response: AxiosResponse<BaseResponse<PermissionRow[]>> = await apiClient<BaseResponse<PermissionRow[]>>({
      ...callConfig,
      endpoint: `/Admin/GetUserRolePermission/${id}`,
    });
      
         
    return {
      res: response.data.rc,
      rs: response.status,
    };
  };

    const saveUserRolePermissons = async (
    payload: SaveUserPermissionsDTO,
    callConfig?: Partial<ApiClientConfig>,
    ) => {
    const response = await apiClient<BaseResponse<NoResult>>({
      ...callConfig,
      endpoint: `/Admin/SaveUserRolePermission`,
      method: 'POST',
      data: payload,
    });

    return response.data.rs;
  };

    const saveUserRole = async (
    payload: AddRole,
    callConfig?: Partial<ApiClientConfig>,
    ) => {
    const response = await apiClient<BaseResponse<NoResult>>({
      ...callConfig,
      endpoint: `/Admin/AddRole`,
      method: 'POST',
      data: payload,
    });

    return response.data.rs;
  };

    const saveUpdateRole = async (
    payload: UpdateRole,
    callConfig?: Partial<ApiClientConfig>,
    ) => {
    const response = await apiClient<BaseResponse<UpdateRoleResponse>>({
      ...callConfig,
      endpoint: `/Admin/UpdateRole`,
      method: 'POST',
      data: payload,
    });

    return {
      rs:response.data.rs,
      res:response.data.res
    };
  };

  const getRolePrivilegePermissionList = async (id: number, callConfig?: Partial<ApiClientConfig>): Promise<BaseResponse<PermissionRow[]>> => {
    const response: AxiosResponse<BaseResponse<PermissionRow[]>> = await apiClient<BaseResponse<PermissionRow[]>>({
      ...callConfig,
      endpoint: `/Admin/GetRolePrivilegePermission/${id}`,
    });
      
         
    return {
      res: response.data.rc,
      rs: response.status,
    };
  };

   const saveRolePrivilegePermissons = async (
    payload: SaveRolePrivilegePermissionsDTO,
    callConfig?: Partial<ApiClientConfig>,
    ) => {
    const response = await apiClient<BaseResponse<NoResult>>({
      ...callConfig,
      endpoint: `/Admin/SaveRolePrivilegePermission`,
      method: 'POST',
      data: payload,
    });

    return response.data.rs;
  };

  return {
    createUser,
    getUser,
    getUsers,
    updateUser,
    getRole,  
    updateUserRole,
    uploadUserProfileImage,   
    updateUserStatus,
    getRoleTypeList ,
    getUserRolePermissionList ,
    saveUserRolePermissons ,
    saveUserRole,
    saveUpdateRole,
    getRolePrivilegePermissionList,
    saveRolePrivilegePermissons,
    createStationMapping,
    getUserMapping
  };
};
